
import { RevCard } from '@ds/components/Card'
import { openModal } from '@ds/components/ModalBase'
import { IconArrowRight } from '@ds/icons/IconArrowRight'

export default {
  components: {
    RevCard,
    IconArrowRight,
  },
  props: {
    label: {
      // currently a translation definition
      type: Object,
      required: true,
    },
    illustration: {
      type: String,
      required: true,
    },
    modalName: {
      type: String,
      required: true,
    },
  },
  methods: {
    openDaModal() {
      openModal(this.modalName)
    },
  },
}
